<template>
  <div class="detail-data-properties">
    <el-collapse v-if="properties.length" v-model="activeGroups">
      <el-collapse-item
        v-for="(group,index) in properties"
        :key="index"
        :title="group.name"
        :name="index"
      >
        <slot name="groupContent" :group="group" />
      </el-collapse-item>
    </el-collapse>
    <div v-else class="empty flex-container flex-column flex-horiz-center flex-verti-center">
      <span>暂无相关数据</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailPropertiesBox',
  props: {
    properties: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      activeGroups: [0],
    }
  },
  watch: {
    'properties.length': {
      handler(value) {
        this.activeGroups = Array.from(new Array(value).keys())
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
  .detail-data-properties{
    overflow: auto;
    .empty{
      height: 100%;
      padding: 128px 0;
      text-align: center;
      color: @theme-grey-3;
    }
  }
</style>
